"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HilFunctionClassDefinition = void 0;
const zod_1 = require("zod");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
var HilFunctionClassDefinition;
(function (HilFunctionClassDefinition) {
    HilFunctionClassDefinition.schema = zod_1.z.object({
        name: zod_1.z.string(),
        functionClass: zod_1.z.string(),
        busRole: zod_1.z.nativeEnum(sigma_engine_shared_1.ComponentFunctionBusRole).optional(),
        functionSignals: zod_1.z.array(zod_1.z.object({
            name: zod_1.z.string(),
            displayName: zod_1.z.string(),
            classSignalDescription: zod_1.z.string(),
            alternateNames: zod_1.z.array(zod_1.z.string()),
            optional: zod_1.z.boolean().optional(),
            isMultiAssignment: zod_1.z.boolean().optional(),
            busType: zod_1.z.nativeEnum(sigma_engine_shared_1.ComponentFunctionBusType).optional(),
            signalTypes: zod_1.z.array(zod_1.z.nativeEnum(sigma_engine_shared_1.SignalDirection)).optional(),
        })),
        supportedAddressingMethods: zod_1.z.array(sigma_engine_shared_1.DesignModels.BusAddressingMethodSchema).optional(),
    });
})(HilFunctionClassDefinition || (exports.HilFunctionClassDefinition = HilFunctionClassDefinition = {}));
//# sourceMappingURL=hil-function-class-definition.js.map